module.exports = __webpack_public_path__ + "static/media/icon_pdf.6a25b272.svg";